import qrcode from 'qrcode';

function generateQRCode(address: string): Promise<string> {
  const thePromise = new Promise<string>((resolve, reject) => {
    qrcode.toDataURL(address).then(resolve).catch(reject);
  });

  return thePromise;
}

export default generateQRCode;
